import { render, staticRenderFns } from "./trip-events-report.vue?vue&type=template&id=23980cf8&"
import script from "./trip-events-report.vue.js?vue&type=script&lang=js&"
export * from "./trip-events-report.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports